export default{
    title: 'light',
    colors:{
        primary: '#118ab2',
        secundary: '#e9c46a',
        text: 'white'
    },
    background: '#eef5f9',
    text: '#333'
}